import { routes } from "src/constants/routes.constants.ts";

export const loginPageB2BRoute = {
  path: routes.root.root,
  lazy: () => import("src/auth/pages/LoginPageB2B/LoginPageB2B.tsx"),
};
